import { render, staticRenderFns } from "./DraftBell.vue?vue&type=template&id=54ed1d71"
import script from "./DraftBell.vue?vue&type=script&lang=js"
export * from "./DraftBell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports